import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { goToLoanRoute } from '../navigation/application-routes';
import { findCurrentLoan, FIND_CURRENT_LOAN_SUCCESS } from '../store/actions/customer-actions';
import history from '../navigation/history';

export default function useLoan() {
  const dispatch = useDispatch();
  const loan = useSelector((state) => state?.personalLending?.loan);
  const device = useSelector((state) => state?.customer?.device);

  const findLoanAndRedirect = useCallback(
    (currentRoute, defaultRoute) => {
      dispatch(findCurrentLoan(device)).then((response) => {
        if (response.type == FIND_CURRENT_LOAN_SUCCESS) {
          const currentLoan = response.payload;
          goToLoanRoute(currentLoan, currentRoute, defaultRoute);
        } else if (response.payload?.status == 401) {
          history.replace('/');
        }
      });
    },
    [device, dispatch],
  );

  return { findLoanAndRedirect, loan, device };
}
